import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import { ConnectAccountParams, SuccessResponse, UpdatePasswordData, UpdateSuccess } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class UserService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}users`;

    public updatePassword(username: string, password: string) {
        return this.post<UpdateSuccess>({
            url: `/${username}/password`,
            headers: {
                'content-type': 'application/json',
            },
            params: {
                password,
                confirmPassword: password
            }
        })
    }

    public postUser(token: string, connectAccountParams: ConnectAccountParams): Observable<SuccessResponse> {
        return this.post<SuccessResponse>({
            url: ``,
            params: connectAccountParams,
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
    }

    public putPassword(token: string, passwordData: UpdatePasswordData, phoneNumber: string): Observable<UpdateSuccess> {
        return this.put<UpdateSuccess>({
            url: `/${phoneNumber}/password`,
            params: passwordData,
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
    }
}